export default __webpack_public_path__ + "static/media/avatar_brown_bear2.7d22a8cf.mp3";